import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M2.5 3.495h17.849v3.246H2.5V3.495zm0 6.49h17.849v3.246H2.5V9.986zm0 9.737H13v-3.246H2.5v3.246zm16.92-4.33l1.08 1.08-2.16 2.16 2.16 2.16-1.08 1.08-2.16-2.16-2.161 2.16-1.08-1.08 2.16-2.16-2.16-2.16 1.08-1.08 2.16 2.16 2.16-2.16z" }));
export default createSvgIcon(iconPath, "Delist");
//# sourceMappingURL=StatusDelistIcon.js.map